import {useEffect, useState} from 'react';
import type {PromoCarouselAutoAdvanceOptions} from './login-signup-promo-carousel.types';
import {PROMO_CAROUSEL_AUTO_ADVANCE_DELAY_MS} from './login-signup-promo-carousel.types';

/** A background tab keeps its timers running, so without this the carousel would keep turning unseen. */
export const useIsDocumentHidden = (): boolean => {
  const [isDocumentHidden, setIsDocumentHidden] = useState(document.hidden);

  useEffect(() => {
    const onVisibilityChange = (): void => {
      setIsDocumentHidden(document.hidden);
    };
    document.addEventListener('visibilitychange', onVisibilityChange);
    return (): void => {
      document.removeEventListener('visibilitychange', onVisibilityChange);
    };
  }, []);

  return isDocumentHidden;
};

/**
 * Restarts the countdown whenever the slide changes, so a slide the user picks from the pagination gets the full
 * delay before the carousel moves on.
 */
export const usePromoCarouselAutoAdvance = ({activeSlideIndex, isPaused, advanceToNextSlide}: PromoCarouselAutoAdvanceOptions): void => {
  useEffect(() => {
    if (isPaused) {
      return undefined;
    }
    const timer = setTimeout(advanceToNextSlide, PROMO_CAROUSEL_AUTO_ADVANCE_DELAY_MS);
    return (): void => {
      clearTimeout(timer);
    };
  }, [activeSlideIndex, isPaused, advanceToNextSlide]);
};
